var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrikethrough(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.92 28.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "strikethrough"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.43,19.96c0,5.12-3.65,8.98-11.21,8.98-5.38,0-9.24-1.8-11.89-4.45l3.28-4.53c1.97,2.05,5.04,3.78,8.9,3.78,3.28,0,4.87-1.56,4.87-3.15,0-1.06-.62-1.77-1.66-2.31h7.55c.1.52.16,1.08.16,1.68ZM32.42,13.28h-8.25c-1.91-.99-4.2-1.51-6.24-1.98-3.23-.75-5.59-1.34-5.59-3.23,0-1.68,1.43-2.86,4.12-2.86s5.76.97,8.02,3.07l3.32-4.37c-2.77-2.56-6.47-3.91-10.92-3.91C10.29,0,6.25,3.78,6.25,8.45c0,2.12.68,3.67,1.75,4.83H1.5c-.83,0-1.5.67-1.5,1.5s.67,1.5,1.5,1.5h30.92c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikethrough);
export default __webpack_public_path__ + "static/media/Strikethrough.a96bf8171d8703f665df7a02ce352ce1.svg";
export { ForwardRef as ReactComponent };